import React from 'react';
import { ArrowDown, ArrowUp } from 'lucide-react';

import type { FileSortDir, FileSortKey } from '@/types/SixDetail.types';
import { classNames } from '@/utils/classNames.utils';

interface SortIndicatorProps {
  activeKey: FileSortKey;
  column: FileSortKey;
  direction: FileSortDir;
}

function SortIndicator({ activeKey, column, direction }: SortIndicatorProps): React.ReactElement | null {
  if (activeKey !== column) return null;

  return direction === 'asc'
    ? <ArrowUp className="ml-1 h-3 w-3" />
    : <ArrowDown className="ml-1 h-3 w-3" />;
}

interface SixDetailFileBrowserTableHeaderProps {
  sortKey: FileSortKey;
  sortDir: FileSortDir;
  onSort: (column: FileSortKey) => void;
  showPathColumn: boolean;
}

function SixDetailFileBrowserTableHeader({
  sortKey,
  sortDir,
  onSort,
  showPathColumn,
}: SixDetailFileBrowserTableHeaderProps): React.ReactElement {
  return (
    <div className={classNames(
      'grid gap-3 border-b border-border bg-muted/40 px-4 py-3 text-sm font-medium text-foreground',
      showPathColumn ? 'grid-cols-14' : 'grid-cols-12',
    )}>
      <button
        type="button"
        className={classNames('flex items-center text-left', showPathColumn ? 'col-span-4' : 'col-span-6')}
        onClick={() => {
          onSort('name');
        }}
      >
        Name
        <SortIndicator activeKey={sortKey} column="name" direction={sortDir} />
      </button>
      {showPathColumn && <div className="col-span-3">Path</div>}
      <button
        type="button"
        className="col-span-1 flex items-center text-left"
        onClick={() => {
          onSort('size');
        }}
      >
        Size
        <SortIndicator activeKey={sortKey} column="size" direction={sortDir} />
      </button>
      <button
        type="button"
        className="col-span-2 flex items-center text-left"
        onClick={() => {
          onSort('modified');
        }}
      >
        Modified
        <SortIndicator activeKey={sortKey} column="modified" direction={sortDir} />
      </button>
      <div className={classNames(showPathColumn ? 'col-span-3' : 'col-span-2')}>Added By</div>
      <div className="text-right">Actions</div>
    </div>
  );
}

export default SixDetailFileBrowserTableHeader;
